import { useContext } from 'react'

import { MarketContext } from '../providers/MarketProvider'

export default function useMarkets() {
  return useContext(MarketContext).markets
}
